/**
 * @generated SignedSource<<1a8eac72ddb852956274e84d7fd855a2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type helpArticlePanel_ZendeskArticleQuery$variables = {
  id: string;
};
export type helpArticlePanel_ZendeskArticleQuery$data = {
  readonly zendeskArticle: {
    readonly body: string | null;
    readonly title: string | null;
  } | null;
};
export type helpArticlePanel_ZendeskArticleQuery = {
  response: helpArticlePanel_ZendeskArticleQuery$data;
  variables: helpArticlePanel_ZendeskArticleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "helpArticlePanel_ZendeskArticleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ZendeskArticle",
        "kind": "LinkedField",
        "name": "zendeskArticle",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "helpArticlePanel_ZendeskArticleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ZendeskArticle",
        "kind": "LinkedField",
        "name": "zendeskArticle",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f30ea39602c091635e4338420a643270",
    "id": null,
    "metadata": {},
    "name": "helpArticlePanel_ZendeskArticleQuery",
    "operationKind": "query",
    "text": "query helpArticlePanel_ZendeskArticleQuery(\n  $id: ID!\n) {\n  zendeskArticle(id: $id) {\n    title\n    body\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab9ce000415553430c974f224421f6db";

export default node;
